import type { ReactNode } from "react";
import { cn } from "@/shared/utils/cn";
import { FullScreenDialog, type DialogDismissReason } from "./FullScreenDialog";
import "./dateTimePicker.css";

interface DateTimePickerLayoutProps {
  onClose: (reason?: DialogDismissReason) => void;
  calendar: ReactNode;
  children: ReactNode;
  footer: ReactNode;
  disabled?: boolean;
  className?: string;
}

export function DateTimePickerLayout({
  onClose, calendar, children, footer, disabled, className,
}: DateTimePickerLayoutProps) {
  return (
    <FullScreenDialog title="Date & time" contentClassName="overflow-hidden" onClose={onClose} footer={
      <div className="mx-auto w-full max-w-[550px] space-y-2">{footer}</div>
    }>
      <div className={cn("date-time-picker mx-auto h-full max-w-[550px] p-4", className)}>
        <fieldset disabled={disabled} className="flex h-full min-h-0 min-w-0 flex-col gap-2">
          <div className="shrink-0 space-y-2">{calendar}</div>
          {children}
        </fieldset>
      </div>
    </FullScreenDialog>
  );
}
